import React from 'react';
import styled from 'styled-components';
import { Link } from 'gatsby';
import Box from 'react-raster';
import Arrow, { ArrowContainer, arrowHoverStyles } from '../Arrow';
import Container from '../Container';

const StyledLink = styled(Link)`
  font-size: 40px;
  display: flex;
  align-items: center;
  text-decoration: none;
  font-weight: 700;
  color: ${({ theme }) => theme.colours.black};
  ${arrowHoverStyles}

  @media (${({ theme }) => theme.mq.l}) {
    font-size: 80px;
  }
`;

const Label = styled.strong`
  margin-right: 40px;
  order: 1;
`;

const StyledArrowContainer = styled(ArrowContainer)`
  order: 2;
`;

function NextBestAction({ ctaUrl, ctaLabel }) {
  return (
    <Container>
      <Box cols={[6, 12]} marginBottom={[0.35, 0.35, 0.7]}>
        <StyledLink to={ctaUrl}>
          <StyledArrowContainer large>
            <Arrow colour="white" large transform="rotate(-90deg)" />
          </StyledArrowContainer>
          <Label>{ctaLabel}</Label>
        </StyledLink>
      </Box>
    </Container>
  );
}

export default NextBestAction;
